// extracted by mini-css-extract-plugin
export default {"footer":"StepFooter_footer__3fxbm"};